import { FC } from 'react';

interface Props {
  loading: boolean;
  addClassName?: string;
}

export const Spinner: FC<Props> = ({ loading, addClassName = 'text-brand' }) => {
  return loading ? (
    <div className="fixed bottom-0 left-0 right-0 top-0 z-[9999] flex items-center justify-center bg-white/50">
      <div
        className={`${addClassName} inline-block h-8 w-8 animate-spin rounded-full border-[3px] border-current border-t-transparent`}
      />
    </div>
  ) : null;
};
